import * as React from 'react';
import { Link } from 'react-router-dom';
import { ActualityExpandMore } from './index';

function WarningBanner(props) {
  if (!props.expand) {
    return null;
  }

  return <ActualityExpandMore expandeMore={props.expand}/>;
}

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {expandeMore: true};
    this.handleToggleClick = this.handleToggleClick.bind(this);
  }

  handleToggleClick() {
    this.setState(state => ({
      expandeMore: !state.expandeMore
    }));
  }

  render() {
    return (
      <div>
        <WarningBanner expand={this.state.expandeMore} />
        <Link
          to={{
            pathname: "#"
          }}
          onClick={this.handleToggleClick}
          aria-label={"Voir moins de détail de l'article"}
        >{this.state.showWarning ? 'Afficher moins' : 'Lire l\'article en entier'}</Link>
      </div>
    );
  }
}

export default Page;